import { PRZELICZNIKI } from 'services/slices/obliczeniaSlice/koszty/constans';

export const calcKwPerPerson = (installed: number) => {
  return (installed / PRZELICZNIKI.Populacja) * 1000000;
};

export const calcZłPerKw = (price: number) => price * 1000;
